import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import {  message } from "antd";
import moment from 'moment'

import EachAccessKey from './EachAccessKey/EachAccessKey';
import { fetchApiKey } from "../../../../actions/api-key";
import { refresh_profile } from "../../../../actions/auth";
import CloudFlyerAPI from '../../../../api/CloudFlyerAPI'

import './KeyList.scss';

// This component gets all the information to create reports
class KeyList extends Component{

    constructor(props) {
        super();
        const { user } = props;

        this.state={
            apiKey:[],
            user:{}
   
        }
    }

    componentDidMount() {
        this.props.fetchApiKey();
        this.props.refresh_profile(true);
    
    }

    componentWillReceiveProps({ apiKey, user }) {
        
        if (apiKey.error) {
          message.error(apiKey.error);
        } else {
          this.setState({
            apiKey: apiKey.items,
            user
          });

        }

    }    

    handleDeleteClick  = (apiId) => {
        
        CloudFlyerAPI
        .user_account
        .deleteApi(apiId)
        .then(response => {
            message.success("Key deleted successfully!")
            this.props.fetchApiKey();
        })
        .catch(err => {
            message.error("Something went wrong.")
        })
    

    }


    render(){
        
        const TableHeader = <ul>
                                <li>Access Key ID</li>
                                <li>Created</li>
                                <li>Status</li>
                                <li>Actions</li>
                            </ul>

        const KeyListGrid=this.state.apiKey.map((kl,index) =>{
            return (
                <EachAccessKey
                    accessKeyId={kl.access_key}
                    date={moment(kl.created_date).format('MMMM Do YYYY, h:mm:ss a')}
                    status={kl.active? 'Active' : 'Deactive'}
                    key={index}
                    id={kl.id}
                    handleDeleteClick = {this.handleDeleteClick}
                />
            )
        })

        return(
            <div className={"keyWrapper"}>
                <div className={"TableHeader"}>
                    {TableHeader}
                </div>
                <div className="ListWrapper">
                    {KeyListGrid}
                </div>
            </div>
        )
    }
}


function mapStateToProps({ apiKey, auth: { user } = {} }) {
    return { apiKey, user };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      fetchApiKey: bindActionCreators(fetchApiKey, dispatch),
      refresh_profile
    };
  }
  
  export default withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(KeyList)
  );
  

